























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IUser } from "@/@types/admin/user/user";

import InputSearch from "@/components/app/search/input-search.vue";

@Component({ components: { InputSearch } })
export default class GuestRegistrationHeader extends Vue {
  @Prop({ type: Array, default: () => [] }) managers!: Array<IUser>;
  @Prop({ type: Array, default: () => [] }) routes!: Array<string>;
  @Prop({ type: Array, default: () => [] }) wievs!: Array<string>;
  @Prop({ type: Object, default: null }) manager!: IUser;
  @Prop({ type: String, default: "" }) route!: string;
  @Prop({ type: String, default: "" }) wiev!: string;
  @Prop({ type: String, default: "" }) registrated!: string;
  @Prop({ type: Boolean, default: false }) spiner!: boolean;
  @Prop({ type: Boolean, default: false }) activeSorts!: boolean;

  regs = ["populated", "new"];

  changeView(view: string): void {
    this.$emit("changeWiev", view);
    localStorage.setItem("guest-list-display-type", view);
  }
}
